export const COLORS = {
  main: '#0f0705',
  accent: '#8eac86',
  secondary: '#e5d097',
  // secondary: '#79261c',
  accent_light: '#c35f2b',
  text: '#e5d097',
  
  mind: '#8eac86',
  blue_light: '#8eac86',
  blue_light_dark: '#5c8074',
  blue_dark: '#254550',
  blue_mid: '#1d574f',
  
  mid_yellow: '#c59332',
  // dark_yellow: '#9e5c30',
  dark_yellow: '#85422e',
  
  light: '#e5d097',
  light_mid: '#b49f83',
  light_dark: '#887066',
  dark: '#0f0705',
  dark_accent: '#2e2a39',
  dark_accent_mid: '#594a66',
  dark_dark: '#1d0f12',
  
  drone: '#79261c',

  wall: '#2e2a39',
  wall_alt: '#2e2a39',

  white: '#eeeeee',
  gaara: '#603030',
  rock_lee: '#155859',
  tenten: '#b75a5e',
  tenten_alt: '#F0D8C0',
  temari: '#423c58',
  temari_alt: '#f0b8f8',
  shino: '#c0cfc8',
  shino_alt: '#353641',
  sasuke: '#103880',
  sasuke_alt: '#b75a5e',
  kiba: '#9c9ca6',
  kiba_alt: '#89193b',
  neji: '#F0D8C0',
  neji_alt: '#353641',
  shikamaru: '#788b78',
  shikamaru_alt: '#353641',
  leaf: '#36635b',
  wraps: '#F0D8C0',

  chakra: '#3e7dc9',
  dirt00: '#2a251f', 
  dirt0: '#dbcdab',
  grass00: '#435035',
  grass0: '#87ac7b',
  base04: '#07111D',
  base03: '#02252e',
  // base03: '#002b36',
  base02: '#073642',
  base01: '#586e75',
  base00: '#657b83',
  // base0: '#96641D',
  base0: '#839496',
  base1: '#93a1a1',
  // base2: '#E19D3F',
  base2: '#eee8d5',
  base3: '#fdf6e3',
  yellow: '#b58900',
  orange: '#cb4b16',
  red: '#dc322f',
  magenta: '#d33682',
  violet: '#6c71c4',
  blue: '#268bd2',
  cyan: '#2aa198',
  green: '#859900',
  black: '#16161d',
  black_accent: '#81708d',
  // // base1: '#07111D',
  // base1: '#0B0B0B',
  // base2: '#5A7178',
  // base3: '#B6ACA3',
  // base4: '#EDF6F1',
  cog1: '#27295f',
  cog2: '#3e7dc9',
  cog3: '#18c0f8',
  cog4: '#86C8E4',
  locust0: '#423a18',
  locust1: '#96641D',
  locust2: '#E19D3F',
  // locust2: '#F89339',
  locust3: '#E7C898',
  flesh1: '#833139',
  flesh2: '#CC7468',
  flesh3: '#DDA78F',
  gray: '#6D7886',
}

COLORS.bg_override = COLORS.dark
COLORS.fg_override = COLORS.dark_accent

export function refreshColors ({bg = COLORS.dark, fg = COLORS.mid_yellow}) {
  COLORS.bg_override = bg
  COLORS.fg_override = fg
  for (let tileKey in TILE_KEY) {
    if (TILE_KEY[tileKey]?.ignoreColorOverride) continue;
    TILE_KEY[tileKey].background = bg
    TILE_KEY[tileKey].foreground = fg
  }
}

export const TILE_KEY = {
  'GROUND': {
    background: COLORS.bg_override || COLORS.dark,
    foreground: COLORS.fg_override || COLORS.dark_accent,
    character: '.',
    sprite: '',
    passable: true,
    lightPassable: true,
    tags: ['PROVIDING_COVER', 'BURNABLE'],
  },
  'FLOOR': {
    background: COLORS.bg_override || COLORS.base02,
    foreground: COLORS.fg_override || COLORS.locust1,
    character: '',
    passable: true,
    lightPassable: true,
    tags: ['BURNABLE'],
  },
  'FREE_FALL': {
    ignoreTransferBackgroundColor: true,
    ignoreColorOverride: true,
    background: COLORS.black || COLORS.dark,
    foreground: COLORS.black_accent || COLORS.dark,
    character: '〣',
    sprite: '〣',
    passable: false,
    lightPassable: true,
    tags: ['FALLING'],
  },
  'ELEVATOR': {
    ignoreColorOverride: true,
    background: COLORS.light || COLORS.wall_alt,
    foreground: COLORS.dark || COLORS.wall,
    character: '█',
    sprite: '█',
    passable: true,
    // lightPassable: true,
    tags: ['EXIT'],
  },
  'WALL': {
    background: COLORS.bg_override || COLORS.wall_alt,
    foreground: COLORS.fg_override || COLORS.wall,
    character: '█',
    sprite: '█',
    passable: false,
    tags: ['BURNABLE', 'WALL'],
  },
  'BURNT': {
    background: COLORS.bg_override || COLORS.base03,
    foreground: COLORS.red,
    character: 'X',
    sprite: '',
    passable: true,
    lightPassable: true,
    ignoreTransferBackgroundColor: true,
    tags: ['BURNABLE'],
    animation: [
      { background: COLORS.bg_override || COLORS.base03, foreground: COLORS.yellow, character: 'X', sprite: '', passable: true, },
      { background: COLORS.bg_override || COLORS.base03, foreground: COLORS.yellow, character: 'x', sprite: '', passable: true, },
      { background: COLORS.bg_override || COLORS.base03, foreground: COLORS.red, character: 'X', sprite: '', passable: true, },
      { background: COLORS.bg_override || COLORS.base03, foreground: COLORS.orange, character: 'x', sprite: '', passable: true, },
      { background: COLORS.bg_override || COLORS.base03, foreground: COLORS.orange, character: 'X', sprite: '', passable: true, },
      { background: COLORS.bg_override || COLORS.base03, foreground: COLORS.red, character: 'x', sprite: '', passable: true, },
      { background: COLORS.bg_override || COLORS.base03, foreground: COLORS.red, character: 'X', sprite: '', passable: true, },
    ]
  },
  'WATER': {
    animation: [
      { background: COLORS.bg_override || COLORS.cog1, foreground: COLORS.cog2, character: '~', passable: false,},
      { background: COLORS.bg_override || COLORS.cog1, foreground: COLORS.cog2, character: '~', passable: false,},
      { background: COLORS.bg_override || COLORS.cog1, foreground: COLORS.cog2, character: '~', passable: false,},
      { background: COLORS.bg_override || COLORS.cog1, foreground: COLORS.cog2, character: '~', passable: false,},
      { background: COLORS.bg_override || COLORS.cog1, foreground: COLORS.cog2, character: '~', passable: false,},
      { background: COLORS.bg_override || COLORS.cog1, foreground: COLORS.cog2, character: '~', passable: false,},
      { background: COLORS.bg_override || COLORS.cog1, foreground: COLORS.cog2, character: '~', passable: false,},
      { background: COLORS.bg_override || COLORS.cog1, foreground: COLORS.cog2, character: '~', passable: false,},
      { background: COLORS.bg_override || COLORS.cog1, foreground: COLORS.cog2, character: '~', passable: false,},
      { background: COLORS.bg_override || COLORS.cog1, foreground: COLORS.cog2, character: '~', passable: false,},
      { background: COLORS.bg_override || COLORS.cog1, foreground: COLORS.cog2, character: '~', passable: false,},
      { background: COLORS.bg_override || COLORS.cog1, foreground: COLORS.cog2, character: '=', passable: false, },
      { background: COLORS.bg_override || COLORS.cog1, foreground: COLORS.cog2, character: '%', passable: false, },
    ],
    background: COLORS.bg_override || COLORS.cog2,
    foreground: COLORS.cog1,
    character: '~',
    passable: false,
    forceAnimate: true,
  },
}

export const TILE_STEP_SOUNDS = {
  'GROUND': [
    'hard_ground_01',
    'hard_ground_02',
    'hard_ground_03',
  ],
  'GROUND_ALT': [
    'hard_ground_01',
    'hard_ground_02',
    'hard_ground_03',
  ],
  'FLOOR': [
    'hard_ground_01',
    'hard_ground_02',
    'hard_ground_03',
    'hard_ground_04',
  ],
  'WATER': [
    'water_01',
    'water_02',
    'water_03',
    'water_04',
    'water_05',
    'water_06',
  ],
  'FREE_FALL': [
    'pass_turn'
  ],
  'BURNT': [
    'grass_00',
    'grass_01',
    'grass_02',
    'grass_03',
    'grass_04',
    'grass_05',
    'grass_06',
    'grass_07',
  ]
}

export const STAT_RENDERERS = {
  'amount': {
    background: COLORS.base04,
    foreground: COLORS.locust2,
    character: '',
  },
  'attackRange': {
    background: COLORS.green,
    foreground: COLORS.base3,
    character: '==>',
  },
  'magazine': {
    background: COLORS.gray,
    foreground: COLORS.base3,
    character: '!!',
  },
  'baseRangedAccuracy': {
    background: COLORS.violet,
    foreground: COLORS.base3,
    character: '*',
  },
  'baseRangedDamage': {
    background: COLORS.red,
    foreground: COLORS.base3,
    character: 'x',
    sprite: '',
  },
  'meleeDamage': {
    background: COLORS.red,
    foreground: COLORS.base3,
    character: 'x',
    sprite: '',
  },
} 

// GiArcheryTarget / GiBullseye / GiCrosshair -- accuracy
// GiBullets -- ammo
// GiBackwardTime -- ammo / reload
//  GiBarbedArrow - -range
// GiBurningDot -- damage
// GiCog

/*
SCROLL-O-Sprites







 
*/
